<template>

  <div v-if="statistics" class="edit-form">
    <h4>Stevnestatistikk</h4>
    <table class="table">
      <tbody>
        <tr>
          <td>Antall deltakere:</td>
          <td>{{statistics.participant_count}}</td>
        </tr>
        <tr>
          <td>Antall øvelser:</td>
          <td>{{statistics.event_count}}</td>
        </tr>
        <tr>
          <td>Antall starter:</td>
          <td>{{statistics.entries_count}}</td>
        </tr>
        <tr v-for="(status, index) in statistics.callroom_status_count" :key="index">
          <td>Antall {{getStatusLabel(status._id) }}:</td>
          <td>{{status.count}}</td>
        </tr>
        <tr v-for="entrytypes in statistics.competition_logentries_eventtype_count" :key="entrytypes._id">
          <td>Antall {{getEventTypeLabel(entrytypes._id) }}:</td>
          <td>{{entrytypes.count}}</td>
        </tr>

      </tbody>      
    </table>
  </div>
</template>

<script>
import StatisticsService from "../services/statistics.service";

export default {
  name: "statistics",
  data() {
    return {
      statistics: null,
      message: ''
    };
  },
  methods: {
    getCompetitionStatistics(id) {
      console.log(`Id: ${id}`);
      StatisticsService.getStatistics(id)
        .then(response => {
          console.log(response.data);
          this.statistics = response.data.returndata;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getStatusLabel(status) {
      // Define labels for different status values
      if (status === true) {
        return "Oppropt";
      } else if (status === false) {
        return "Ikke oppropt";
      } else {
        return status; // Return the status itself if it's not true/false
      }
    },
    getEventTypeLabel(_id) {
      if ( _id === "login" ) {
        return "pålogginger deltakerlink"
      } else if ( _id === "updateCallroomStatus" ) {
        return " oppropsendringer deltaker"
      } else if ( _id === "updateCallroomStatus_ModeratorOverride" ) {
        return " oppropsendringer arrangør"
      } else if ( _id === "vippslogin_competitionmatch" ) {
        return "pålogginger deltaker vipps"
      } 
    }
  },
  mounted() {
    console.log("Statistics - mounted")
    this.message = '';
    this.getCompetitionStatistics(this.$route.params.competition_id);
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        console.log(`Watch triggered: ${toParams}  - ${previousParams}`)
        this.getCompetitionStatistics(this.$route.params.competition_id);
        // react to route changes...
      }
    )
  }
};
</script>

<style>
.edit-form {
  max-width: 300px;
  margin: auto;
}
</style>
